import Cookies from 'components/ui/Cookies';
import Footer from 'components/ui/Footer';
import useAppSelector from 'hooks/useAppSelector';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { SkeletonTheme } from 'react-loading-skeleton';
import styled from 'styled-components/macro';
import { selectShowHero } from 'store/reducers/shopSlice';
import ExportPdfWorker from './Export/ExportPdfWorker';
import MainNavigation from './MainNavigation';

const Layout = ({ children }: { children: React.ReactNode }) => {
    const { t } = useTranslation();
    const { shop } = useAppSelector(({ shop }) => shop);
    const location = useLocation();
    const homePage = location.pathname === '/';
    const showHero = useAppSelector(selectShowHero);

    return (
        <SkeletonTheme baseColor="#f6f6f6" highlightColor="#efefef">
            <StyledContainer $showHero={!!showHero} $homePage={homePage}>
                <MainNavigation loginLabel={t('signin')} logoutLabel={t('signout')} />
                <MainContent>{children}</MainContent>
                <Footer footerInfo={shop?.footerInfo} />
                <Cookies />
            </StyledContainer>
            <ExportPdfWorker />
        </SkeletonTheme>
    );
};

const StyledContainer = styled.div<{ $showHero: boolean; $homePage: boolean }>`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    padding-top: ${({ $showHero, $homePage }) => (!$showHero || !$homePage ? '130px' : '0px')};

`;

const MainContent = styled.main`
    flex: 1 0 auto;
    width: 100%;
    max-width: ${({ theme }) => `${theme.breakpoints.xl}px`};
    margin: 0 auto;
`;

export default Layout;
